import appConfig from 'config';
import { SERVICES } from 'tenant/utils';

const identify = ({ user = {} }) => {
  if (!SERVICES.INSPECTLET) return;
  window.__insp?.push([
    'tagSession',
    {
      user_id: user?.id,
      company_name: user?.company_name,
      appVersion: appConfig.APP_VERSION,
    },
  ]);
};

const tagSession = ({ tag }) => {
  if (!SERVICES.INSPECTLET) return;
  return window.__insp?.push(['tagSession', tag]);
};

const trackEvent = ({ eventName }) => {
  if (!SERVICES.INSPECTLET) return;
  return window.__insp?.push(['tagSession', eventName]);
};

export { identify, tagSession, trackEvent };
